/**
 * Is a plate being made for this job?
 *
 * The pipeline answers it. Numbering Plate Making onto a job card is what says
 * a plate is being made; leaving it off says none is. There used to be a
 * `plate_required` dropdown as well, which generated the stage — two records of
 * one decision, and screens split between reading one and reading the other.
 */

export const PLATE_STAGE_KEY = 'plate_making';

/** Whether Plate Making was numbered onto this pipeline. */
export function pipelineHasPlate(stages) {
  return (stages || []).some((stage) => stage?.stage_key === PLATE_STAGE_KEY);
}

/** Whether a plate is being made for this line item or job card. */
export function needsPlate(entity) {
  return pipelineHasPlate(entity?.production_stages);
}

/** Where the plate has got to: `pending` until it goes out, then `ordered`, then `received`. */
export function plateStatus(entity) {
  if (entity?.plate_status === 'received' || entity?.plate_received_at || entity?.plate_received) {
    return 'received';
  }
  if (entity?.plate_status === 'ordered' || entity?.plate_ordered_at || entity?.plate_ordered) {
    return 'ordered';
  }
  return 'pending';
}
